export default __webpack_public_path__ + "static/media/new-msat-modal-3.b59cb5c3.svg";